var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAviationCollide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 39,
    viewBox: "0 0 167 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 13L28.5 1L40.5 7L1 1L44 13L55.5 19L101.5 13Z",
    fill: "url(#paint0_linear_212_9102)",
    stroke: "#13FFDA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 32L139 20L127 26L166.5 20L123.5 32L112 38L66 32Z",
    fill: "url(#paint1_linear_212_9102)",
    stroke: "#13FFDA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_212_9102",
    x1: 51.25,
    y1: 1,
    x2: 51.25,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_212_9102",
    x1: 116.25,
    y1: 20,
    x2: 116.25,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DA6FF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviationCollide);
export default __webpack_public_path__ + "static/media/aviation-collide.569c069a2503bd0b5efe7ac9b2add46b.svg";
export { ForwardRef as ReactComponent };